import { Fragment } from 'react';
import Meta from './../components/Meta';
import LandingPage from './../components/LandingPage';

function IndexPage() {
  return (
    <Fragment>
      <Meta title="Showrunner - Discover Art Shows Near You" />
      <LandingPage />
    </Fragment>
  );
}

export default IndexPage;
